<div class="modal-header">
    <div class="preview-buttons">
        <h4 class="modal-title">Preview Video - {{title}}</h4>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close(false)"></button>
</div>
<div class="modal-body">
    <div id="videoContainer" style="text-align: center"></div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-raised btn-secondary me-2" (click)="modal.close(false)">
        Close
    </button>
    <button type="button" class="btn btn-raised btn-success" (click)="modal.close(true)">
        Confirm
    </button>
</div>